import {Grupo} from './grupo.model';
import {ActiveDirectoryModel} from '.././parametros/activeDirectory-model';

export class GrupoAdModel {

  id?: number;
  grupo?: Grupo;
  nome?: string;
  ldapEnabled?: boolean;
  ldapUrl?: string;
  ldapDomain?: string;
  ldapSearchBase?: string;
  ldapSearchFilter?: string;
  ldapManagerDn?: string;
  ldapManagerPassword?: string;
  erroConexao?: boolean;
  erroConexaoObservacao?: string;



  constructor(ad: ActiveDirectoryModel){
    this.nome = ad.nome;
    this.ldapEnabled = ad.ativo;
    this.ldapUrl = ad.ldapUrl;
    this.ldapDomain = ad.dominio;
    this.ldapSearchBase = ad.ldapManagerBase;
    this.ldapSearchFilter = ad.ldapManagerFilter;
    this.ldapManagerDn = ad.ldapManagerDn;
    this.ldapManagerPassword = ad.ldapManagerPassword;
  }

}
